import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.scout-report-measurement-type-form', () => {
  void import('./internal/scout-report-measurement-type-form')
    .then(({ default: Component }) => Component());
});
